module.exports = __webpack_public_path__ + "static/media/notification.4d747afa.ogg";